package br.com.texeratx.boardgametimeapp.ui.feedback

import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppSnackbarTone
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow

sealed interface AppUiEvent {
    data class UiMessage(
        val message: String,
        val tone: AppSnackbarTone = AppSnackbarTone.Info
    ) : AppUiEvent

    data class GameDeleted(val message: String) : AppUiEvent
    data class PlayerDeleted(val message: String) : AppUiEvent
    object ClanUpdated : AppUiEvent
    object SessionExpired : AppUiEvent
}

object AppUiEventBus {
    private val _events = MutableSharedFlow<AppUiEvent>(extraBufferCapacity = 1)
    val events = _events.asSharedFlow()

    fun publish(event: AppUiEvent) {
        _events.tryEmit(event)
    }

    fun publishMessage(message: String, tone: AppSnackbarTone = AppSnackbarTone.Info) {
        publish(AppUiEvent.UiMessage(message = message, tone = tone))
    }
}
